import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['input', 'container', 'savePrescriptionLink']

  connect() {
    let selected = null
    let $typeahead = $(this.inputTarget).typeahead(
      {},
      {
        display: 'name',
        limit: 25,
        source: (query, syncResults, asyncResults) => {
          $.get(`${this.data.get('url')}?term=${encodeURI(query)}`, function (data) {
            asyncResults(data);
          });
        },
        templates: {
          notFound: (data) => {
            return this.registerDrugLink(data)
          },
          footer: (data) => {
            return this.registerDrugLink(data)
          }
        }
      }
    ).bind('typeahead:select typeahead:autocomplete', (e, data) => {
      $typeahead.typeahead('val', '')
      $(this.savePrescriptionLinkTarget).removeClass('hidden')
      $.ajax({
        url: `/drugs/${data['id']}`
      }).done((data) => {
        $(this.containerTarget).append(data)
      })
    })
  }

  registerDrug() {
    $('.tt-input').typeahead('val', '')
    $(this.savePrescriptionLinkTarget).removeClass('hidden')
    $.ajax({
      url: '/drugs',
      method: 'POST',
      data: { name: this.data.get('query') },
      headers: {
        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
      },
    }).done((data) => {
      $(this.containerTarget).append(data)
    })
  }


  teardown() {
    $('.tt-input').typeahead('destroy')
  }

  registerDrugLink(data) {
    this.data.set('query', data['query'])
    return `<div class="prescription-typeahead" data-action="click->drug-autocomplete#registerDrug"><strong>Cadastrar medicamento "${data['query']}"</strong></div>`
  }
}
